import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IUpdateApproval } from "mobx-stores/_models/products/approval";
import { date, string } from "yup";
export const getApprovalFormSchema = (): ObjectSchemaType<IUpdateApproval> => ({
  businessNumber: {
    gridSize: 4,
    label: "Số ký duyệt - mẫu",
    type: InputType.text,
    validattionYupSchema: string().max(255),
  },
  businessDate: {
    gridSize: 4,
    label: "Ngày ký duyệt - mẫu",
    type: InputType.datePicker,
    validattionYupSchema: date().nullable(),
  },
  businessExpiredDate: {
    gridSize: 4,
    label: "Hạn dùng - mẫu",
    type: InputType.datePicker,
    validattionYupSchema: date().nullable(),
  },

  printNumber: {
    gridSize: 4,
    label: "Số ký duyệt - In ấn",
    type: InputType.text,
    validattionYupSchema: string().max(255),
  },
  printDate: {
    gridSize: 4,
    label: "Ngày ký duyệt - In ấn",
    type: InputType.datePicker,
    validattionYupSchema: date().nullable(),
  },
  printExpiredDate: {
    gridSize: 4,
    label: "Hạn dùng - In ấn",
    type: InputType.datePicker,
    validattionYupSchema: date().nullable(),
  },
  customerRequest: {
    gridSize: 12,
    label: "Yêu cầu khách hàng",
    type: InputType.textArea,
    metaData: {
      rows: 3,
    },
    validattionYupSchema: string().max(255),
  },
});
